module.exports = __webpack_public_path__ + "img/bg_radio_active.81c856d3.svg";